import React, { useEffect, useRef, useState } from 'react';

import './OpenedPositions.scss';
import { DashboardLayout } from '../../UserView/DashboardLayout';
import Page from '../../Page/Page';
import ControlsGroup from '../../../components/ui/ControlsGroup/ControlsGroup';
import { FormattedMessage, useIntl } from 'react-intl';
import OpenedPositionsFilters from './OpenedPositionsFilters/OpenedPositionsFilters';
import OpenedPositionsTable from '../../../components/ui/Table/OpenedPositionsTable';
import { getOpenedPositions } from '../../../api/opened-positions';

const OpenedPositions = () => {
  const [isListLoading, setIsListLoading] = useState(true);
  const [filters, setFilters] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [symbolList, setSymbolList] = useState([]);
  
  const componentMounted = useRef(true);
  const intl = useIntl();

  document.title = intl.formatMessage({
    id: 'menu.openedPositions',
    defaultMessage: 'Opened Positions',
  });

  useEffect(() => {
    getTradingList(null, null);

    return () => {
      componentMounted.current = false;
    };
  }, []);

  const getTradingList = (options, data) => {
    setIsListLoading(true);    
    getOpenedPositions(getTablePageParams(options, data))
      .then((res) => {
        if (componentMounted.current && !res.errors) {
          setTableData(res.data.data);
          const opt = res?.data?.ticker.map((opt) => ({
            value: opt,
            label: opt,
          }));
          setSymbolList(opt);
          setIsListLoading(false);
        }
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setIsListLoading(false);
      })
  };

  const getTablePageParams = (options, filter) => {
    let params = ''
    if (filter) {
      if (filter && filter.trading_account) {
        params = `&trading_account=${filter.trading_account}`;
      }
      if (filter && filter.symbol) {
        params = `&symbol=${filter.symbol}`;
      }
      if (filter && filter.open) {
        params = `${params}&open[from]=${filter.open.from}&open[to]=${filter.open.to}`;
      }
      return params;
    }

    return params;
  };

  return (
    <DashboardLayout>
      <Page
        title={<FormattedMessage id={'menu.openedPositions'} defaultMessage={'Opened Positions'} />}
      >
        <div className='opened-position__page'>
          <ControlsGroup>
            <OpenedPositionsFilters
              onSubmit={(data) => {
                if (!filters && !data) {
                  return;
                }
                if (filters && !data) {
                  getTradingList({ navigate: 'first' }, null);
                  setFilters(null);
                } else {
                  setFilters(data);
                  getTradingList({ navigate: 'first' }, data);
                }
              }}
              reloadFilters={isListLoading}
              symbolList={symbolList}
            />

            <div className={'trading-table'}>
              <OpenedPositionsTable
                data={tableData}
                perPage={200}
                showLoader={isListLoading}
              />
            </div>
          </ControlsGroup>
        </div>
      </Page>
    </DashboardLayout>
  );
};

export default OpenedPositions;
